<template>
	<div class="mainBox" :class="router == '/contact' ? 'active':''">
		<header class="headBox row">
<!--      <title>中明科技-致力于提供经济 · 绿色 · 稳定 · 规模 · 高效的算力服务，提供人工智能行业的可持续发展。</title>-->
<!--      <meta name="description" content="依托在可再生能源领域的技术和经验优势，绿色电力和智能算力协同发展 ，以绿色能源为基础，算力资源为核心，数据要素为支撑，全面服务人工智能产业的发展，助力产业数字化和智能化持续升级助推生产范式变革，实现 '双碳'目标与数字经济协同发展，为构建绿色、智能、可持续的未来社会贡献力量。">-->
<!--      <meta name="keywords" content="中明科技,中明算力云,高性能GPU,算力,智算,裸金属,算力租赁,数据中心,4090显卡多少钱，">-->
			<router-link to="/" class="fl">
				<img src="../../assets/img/lib/logo.png" class="logo">
			</router-link>
			<div class="desBox flexBox fr">
				<ul class="navList flexBox">
					<li v-for="item in navList">
						<template v-if="item.children">
							<a-dropdown>
								<div class="item" @click="e => e.preventDefault()">
									{{item.name}} <a-icon type="down" />
								</div>
								<a-menu slot="overlay" class="mainDrop">
									<a-menu-item :key="idx" v-for="(res,idx) in item.children">
										<router-link :to="res.url" class="item">
											{{res.name}}
										</router-link>
									</a-menu-item>
								</a-menu>
							</a-dropdown>
						</template>
						<template v-else>
							<router-link :to="item.url" class="item">
								{{item.name}}
							</router-link>
						</template>
					</li>
				</ul>
				<i class="line"></i>
				<router-link to="/">
					<div class="txt" @click="clickDoc">文档中心</div>
				</router-link>
				<div class="txt" @click="clickJump" v-if="userData">控制台</div>
				<email-modal v-model="editEmail" :type="emailModalType" @success="handleEmailSuccess" />
				<div class="btn" @click="clickLogin" v-if="userData == null">
					登录/注册
				</div>
				<template v-else>
					<a-dropdown>
						<div class="userInfo flexBox" @click="e => e.preventDefault()">
							<img :src="userData.avatar" class="avatar">
							<div class="nick">{{userData.username}}</div>
							<a-icon type="down" />
						</div>
						<a-menu slot="overlay" class="userDrop">
							<a-menu-item>
								<div class="item" @click="jumpAdmin">
									个人中心
								</div>
							</a-menu-item>
							<a-menu-item>
								<div class="item" @click="clickLogout">
									退出
								</div>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</template>

			</div>
		</header>
		<router-view></router-view>
		<footer class="footBox">
			<div class="fl flexBox">
				<img src="../../assets/img/lib/logo.png" class="logo">
				<div class="desBox">
					<div class="contact flexBox">
						<div class="txt">售前咨询<span>0313-2026969-8010</span> / <span>15631383161</span>（日间）</div>
						<div class="txt" style="margin: 0 2rem 0 4rem;">售后咨询<span>0313-2026969-8019</span> （日间）<span>0313-2026969-8001</span> /<span>15631385737</span>（夜间17:30-8:30)</div>
	
					</div>
					<div class="contact flexBox">
						<div class="txt" >联系邮箱<span>cloud-service@zminfra.cn</span></div>
						<div class="txt" style="margin: 0 2rem;">人才招聘邮箱<span>HR@zminfra.cn</span></div>
					</div>
					<div class="info flexBox">
						<div class="txt">版权所有© 张家口中明科技有限公司 保留所有权利<span style="margin: 0 1rem;"></span>冀ICP备2025114240号
						</div>
					</div>
				</div>
			</div>
			<div class="fr">
				<div class="codeBox">
					<img src="../../assets/img/lib/icon_1.png" class="icon">
					<div class="txt">售后咨询</div>
				</div>
			</div>
			<div class="fr">
				<div class="codeBox"  style="margin-right: 4rem;">
					<img src="../../assets/img/lib/icon_2.png" class="icon">
					<div class="txt">售前咨询</div>
				</div>
			</div>
		</footer>

		<div class="fixedBox">
			<img src="../../assets/img/lib/online.png" class="icon">
			<div class="modelBox">
				<p class="name">售前咨询</p>
				<img src="../../assets/img/lib/icon_1.png" class="code">
				<p class="tip">日间客服热线</p>
				<p class="phone0">0313-2026969-8010</p>
				<p class="phone">15631383161</p>
	
				<p class="name" style="border-top:#dfdfdf solid 1px; margin-top: 1rem; padding-top: 1rem;">售后咨询</p>
				<img src="../../assets/img/lib/icon_2.png" class="code">
				<p class="tip">日间客服热线</p>
				<p class="phone0">0313-2026969-8019</p>
				<p class="tip">（夜间17:30-8:30)</p>
				<p class="phone0">0313-2026969-8001</p>
				<p class="phone">15631385737</p>
			</div>
			<a v-if="showHdIcon" :href="hdIconLink" target="_blank">
				<img src="../../assets/img/lib/ico_hd.png" class="iconhd">
			</a>
		</div>
		
		
		
	</div>
</template>

<script>
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b2291d7aef75093ccb9dcfc2e3e4d2fa";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
	import GlobalInfo from '../../components/GlobalInfo.vue';
	import EmailModal from '../../components/com/EmailModal.vue';
	export default {
		name: 'Main',
		components: {EmailModal},
		data() {
			return {
				navList: [{
					name: "首页",
					url: "/"
				}, {
					name: "算力产品",
					url: "/product"
				}, {
					name: "模型市场",
					url: "/agora"
				}, {
					name: "解决方案",
					url: "/solution"
				}, {
					name: "了解中明集团",
					children: [{
						name: "新闻资讯",
						url: "/new"
					}, {
						name: "联系我们",
						url: "/contact"
					}, {
						name: "关于我们",
						url: "/about"
					}, {
						name: "招贤纳士",
						url: "/recruit"
					}]
				}],
				userData: null,
				router: null,
				showHdIcon: false,
				hdIconLink: '',
				editEmail: false,
				emailModalType: 'bind', // 'edit' 或 'bind'
			}
		},
		watch: {
			$route() {
				this.router = this.$route.path;
			}
		},
		mounted() {
			this.router = this.$route.path;
			this.$tools.getUserInfo(
				(data) => {
					this.userData = data;
				},
				() => {
					this.reset();
				}
			);
			this.getUserInfo();
			this.checkHdIconStatus();
		},
		methods: {
			getUserInfo() {
				this.$tools.getUserInfo(
				(data) => {
					this.userData = data;
				},
				() => {
					this.reset();
				}
			)},
			clickDoc() {
				this.$tools.checkLoginAndJump("https://console.cloud-ming.com/console/portal/help-center/overview");
			},
			goDashboard() {
				this.$tools.checkLoginAndJump("https://console.cloud-ming.com/console/portal/dashboard");
			},
			clickJump() {
				// 是否已绑定邮箱
				if(this.userData.email == "" || this.userData.email == "cloud-service@zminfra.cn"){
					this.emailModalType = 'bind' ;
					this.editEmail = true;
				}else{
					this.goDashboard();
				}
			},
			handleEmailSuccess() {
				// 邮箱操作成功后的回调函数
				// 更新用户信息
				this.getUserInfo();
				this.goDashboard();
			},
			clickLogin() {
				this.$tools.userLogin(
					location.href,
					(data) => {
						window.location.href = data;
					},
					(msg) => {
						this.$message.error(msg);
					}
				);
			},
			jumpAdmin() {
				this.$router.push("/admin")
			},
			clickLogout() {
				this.$tools.userLogout(
					() => {
						this.$message.success("注销成功!");
						this.reset();
					},
					(msg) => {
						this.$message.error(msg);
					}
				);
			},
			reset() {
				this.userData = null;
			},
			checkHdIconStatus() {
				this.$req('get', '/api/cms/page/active')
					.then(response => {
						if (response.code == 200&&response.data) {
							this.showHdIcon = true;
							// 这里可以根据接口返回的数据设置链接地址
							// 假设接口返回的数据中包含链接信息
							this.hdIconLink = GlobalInfo.HTTPURL+"/pageDes?id="+response.data.id;
						} else {
							this.showHdIcon = false;
						}
					})
					.catch(error => {
						console.error('获取图标状态失败:', error);
						this.showHdIcon = false;
					});
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/portal/head.css");
	@import url("../../assets/css/portal/foot.css");
</style>